import { Component, Input, input } from '@angular/core';

@Component({
  selector: 'lib-spacer',
  imports: [],
  templateUrl: './spacer.component.html',
  styleUrl: './spacer.component.scss'
})
export class SpacerComponent {
@Input() data!: any;
}
